<script>
import { _request } from '@/helpers/_request.js'
import Parser from '@/helpers/_responseParser'

export default {
  name: 'RecipientService',
  methods: {
    getRecipients () {
      return _request('GetRecipients').then(Parser.toXml.bind(null, 'GetRecipientsResponse'))
    },
    getRecipient (RecipientID = '') {
      return _request('GetRecipients', { RecipientID }).then(Parser.toXml.bind(null, 'GetRecipientsResponse'))
    },
    getRecipientFields (RemittanceOptionId = 2) {
      return _request('GetRecipientFields', { RemittanceOptionId }).then(Parser.toXml.bind(null, 'GetRecipientFieldsResponse')).catch((err) => new Promise((resolve, reject) => reject(err)))
    },
    changeRecipients (data, OperationType) {
      Object.entries(data).forEach(([key, el]) => {
        if (key === 'MobileNumber' && typeof el.value === 'object') {
          data[key] = `+${el.value.firstPart + el.value.secondPart}`
        } else if (key !== 'CustomProperties') {
          data[key] = el.value
        }
      })
      const recipient = {
        OperationType,
        Recipient: {
          RemitDisabled: false,
          ...data
        }
      }
      return _request('ChangeRecipient', recipient).then(Parser.toXml.bind(null, 'ChangeRecipientResponse'))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/services/RecipientService.vue